export class PermissionModel {
  PlantCode: string;
  PermissionId: number;
  Description: string;
}
